import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import fImg from '../../images/background/3.jpg'


const FaqSection = (props) => {

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (

        <section className="faq-one" style={{ backgroundImage: `url(${fImg})` }}>
            <div className="auto-container">
                <div className="sec-title light centered">
                    <div className="sec-title_title">Frequently Asked Questions</div>
                    <h2 className="sec-title_heading">Our Previous Lush Head's <br /> Frequently Asked Question</h2>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <ul className="accordion-box">
                            <li>
                                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="accordion block active-block">
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography>What fitness level is required? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            Our retreats are designed for all fitness levels. Activities can be modified to accommodate individual needs.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>
                            <li>
                                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className="accordion block active-block">
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography> Is this suitable for solo travelers? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                          Absolutely! Most participants come solo and leave with lifelong connections.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>
                            <li>
                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className="accordion block active-block">
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography> What should I pack? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                           We provide a detailed packing list upon booking. Focus on comfortable, weather-appropriate clothing and an open mind.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <ul className="accordion-box">
                            <li className="accordion block">
                                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography>Are vegetarian/vegan meals available? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                           Yes, we cater to all dietary requirements. Please inform us during booking.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>
                            <li className="accordion block">
                                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography>What is the main focus of the retreat? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            Our primary goal is to foster meaningful connections and collaborative growth. The retreat balances structured networking and skill-sharing workshops with unstructured time for organic conversations and personal reflection.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>
                            <li className="accordion block">
                                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={""}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className='acc-btn'
                                    >
                                        <Typography>Is there an application process to attend? <div className="icon fa fa-angle-down"></div></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            Yes, we have a simple application to ensure the group is a good fit for our collaborative and immersive environment. We curate the circle to bring together diverse, forward-thinking individuals ready to share and learn.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default FaqSection;